module.exports = "/matchcenter-staging/assets/images/matchcenter_tabs_arrow.d355210baf468768dd678582daa9b8f2.svg";